/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 * 
 * These generated files were originally generated as part of the Azure Monitor OpenTelemetry project.
 * They are copied here to provide accurate type information for our tests.
 */

export * from "./models";
